import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
	name: 'expiresIn',
})
export class ExpiresInPipe implements PipeTransform {
	transform(value: Date | string): string {
		const now = moment();
		const expiryDate = moment(value);
		const duration = moment.duration(expiryDate.diff(now));

		if (duration.asDays() >= 1) {
			const daysValue = Math.round(duration.asDays());
			return `${daysValue} ${daysValue > 1 ? 'days' : 'day'}`;
		} else if (duration.asHours() >= 1) {
			const hoursValue = Math.round(duration.asHours());
			return `${hoursValue} ${hoursValue > 1 ? 'hours' : 'hour'}`;
		} else {
			const minutesValue = Math.round(duration.asMinutes());
			if (minutesValue <= 0) {
				return '0 minute';
			}
			return `${minutesValue} ${minutesValue > 1 ? 'minutes' : 'minute'}`;
		}
	}
}
